<template>
  <div class="columns">
    <div class="column is-one-third"/>
    <div class="column is-one-third">
      <progress data-test="progress" class="progress is-primary is-small" />
    </div>
    <div class="column is-one-third"/>
  </div>
</template>
